import React from "react";
import { Warning } from "@phosphor-icons/react";

// Sitewide notice shown only while the external Cardano data API is degraded —
// auto-hides within ~60s once it recovers. `maintenance` + `apiStatus` are
// passed down from App.js's single useExternalStatus() call so this banner
// always reflects the same value everywhere it's rendered.
//
// The message is specific to the detected condition. Note the banner only
// appears for a CONFIRMED problem (the backend sends maintenance=true only for
// db_down, and optionally sync_stalled); a "status unknown" / unreachable blip
// deliberately does NOT raise this banner.
const MESSAGES = {
  db_down: "Data provider's database is currently down — on-chain data may be unavailable. Please check back shortly.",
  sync_stalled: "Live chain data is briefly paused while the provider catches up — values may be a few minutes behind.",
};

export const MaintenanceBanner = ({ maintenance, apiStatus }) => {
  if (!maintenance) return null;

  const message =
    MESSAGES[apiStatus] || "Website currently in maintenance mode — please check back later.";

  return (
    <div
      data-testid="maintenance-banner"
      data-status={apiStatus || "unknown"}
      className="bg-red-950/70 border-b border-red-500/40 text-red-300 px-6 py-2.5 flex items-center justify-center gap-2 text-[11px] uppercase tracking-[0.15em] mono"
    >
      <Warning size={14} />
      {message}
    </div>
  );
};
